import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { ConfigProvider, Modal, Button } from 'antd';
import { CrownOutlined } from '@ant-design/icons';
import zhCN from 'antd/locale/zh_CN';
import { Provider, useSelector } from 'react-redux';
import store, { RootState } from './store';
import { selectUser } from './store/userSlice';
import LandingView from './pages/LandingView';
import AuthView from './pages/AuthView';
import MainLayout from './components/layout/MainLayout';
import MainView from './pages/MainView';
import ProfileView from './pages/ProfileView';
import ResetPasswordView from './pages/ResetPasswordView';
import VerifyEmailView from './pages/VerifyEmailView';
import ComingSoon from './pages/ComingSoon';
import PricingView from './pages/PricingView';
import ChatPage from './pages/ChatPage';

// 路由保护组件
const ProtectedRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const user = useSelector(selectUser);
  const projects = useSelector((state: RootState) => state.project.projects);
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = React.useState(false);

  React.useEffect(() => {
    if (!user?.isPremium && projects.length > 1) {
      setModalVisible(true);
    }
  }, [user, projects]);

  return (
    <>
      {element}
      <Modal
        title={<div style={{ textAlign: 'center' }}><CrownOutlined style={{ fontSize: '24px', color: '#faad14' }} /></div>}
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          navigate('/app');
        }}
        footer={null}
        width={400}
        centered
      >
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <h3 style={{ marginBottom: '16px' }}>非会员项目数量超限</h3>
          <p style={{ color: '#666', marginBottom: '24px' }}>
            非会员用户只能创建1个项目，您可以：<br />
            1. 在项目列表中删除多余的项目<br />
            2. 升级到专业版享用无限项目额度
          </p>
          <Button 
            type="primary" 
            block
            onClick={() => {
              setModalVisible(false);
              navigate('/pricing');
            }}
          >
            升级专业版
          </Button>
        </div>
      </Modal>
    </>
  );
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ConfigProvider locale={zhCN}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/" element={<LandingView />} />
            <Route path="/auth" element={<AuthView />} />
            <Route path="/reset-password" element={<ResetPasswordView />} />
            <Route path="/verify-email" element={<VerifyEmailView />} />
            <Route path="/profile" element={<ProfileView />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/app" element={<MainLayout />}>
              <Route index element={<MainView />} />
              <Route path="chat/:projectId/:stage" element={<ChatPage />} />
            </Route>
            <Route path="/pricing" element={<PricingView />} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  );
};

export default App; 